import React, {useState} from "react";
import {  useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";
import {RootState, useAppDispatch} from "../../../redux/store";
import {useSelector} from "react-redux";
import {resetUtente, UtenteLogged} from "../../authentication/authenticationSlice";
import {resetUserStored, updateRememberedUsername, UserStored} from "../../userPreference/userPreferenceSlice";

const ProfileMenu = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const theme = useTheme();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const utente = useSelector<RootState, UtenteLogged>(
        (state) => state.authentication.utenteLogged
    );

    const userStored = useSelector<RootState, UserStored | undefined>(
        (state) => state.userPreferenceState.userStored
    );

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // ✅ MIGLIORATO: logout con opzioni per remembered username
    const handleLogOut = () => {
        // ✅ NUOVO: mantieni username se era remembered
        const shouldKeepUsername = userStored?.rememberUsername && userStored?.username;

        dispatch(resetUtente());

        if (shouldKeepUsername) {
            // Mantieni solo username, rimuovi tutto il resto
            dispatch(updateRememberedUsername({
                username: userStored!.username!,
                remember: true
            }));
        } else {
            dispatch(resetUserStored());
        }

        setAnchorEl(null);
        navigate("/signin");
    };

    // ✅ NUOVO: logout completo (rimuove anche username)
    const handleLogOutCompletely = () => {
        dispatch(resetUtente());
        dispatch(resetUserStored());
        setAnchorEl(null);
        navigate("/signin");
    };

    return (
        <>
            <Button
                sx={{ color: theme.palette.secondary.main }}
                aria-controls="profile-menu"
                onClick={handleClick}
                size="small"
                color="inherit"
            >
                {utente.username}
                <AccountCircle sx={{ ml: 1 }} />
            </Button>
            <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                // ✅ NUOVO: migliore posizionamento
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem onClick={handleClose} component={Link} to="/me">
                    Profile
                </MenuItem>
                <MenuItem
                    onClick={handleClose}
                    component={Link}
                    to="/me/changepassword/"
                >
                    Cambia Password
                </MenuItem>

                {/* ✅ NUOVO: divider visivo */}
                <div style={{ borderTop: '1px solid #e0e0e0', margin: '4px 0' }} />

                {/* ✅ MIGLIORATO: opzioni logout differenti */}
                {userStored?.rememberUsername ? (
                    <>
                        <MenuItem onClick={handleLogOut}>
                            Logout (mantieni username)
                        </MenuItem>
                        <MenuItem onClick={handleLogOutCompletely}>
                            Logout completo
                        </MenuItem>
                    </>
                ) : (
                    <MenuItem onClick={handleLogOut}>
                        Logout
                    </MenuItem>
                )}
            </Menu>
        </>
    );
};

export default ProfileMenu;
